import { abrePDF } from "../../../utils/pdf";
import { fDMA } from "../../../utils/fecha";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import PasswordCliente from "./PasswordCliente";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from "xlsx";

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  // const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  // const URL_DEPARTAMENTOS_CLIENTES =
  //   process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;


  // const [grupos, setGrupos] = useState([]);
  // const [selectedGrupo, setSelectedGrupo] = useState("");
  // const [departamentos, setDepartamentos] = useState([]);
  // const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [mailTo, setMailTo] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [idEditCliente, setIdEditCliente] = useState("");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [selectedDepartamentoEdit, setSelectedDepartamentoEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [codigo, setCodigo] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [selectedVendedorName, setSelectedVendedorName] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [calificadora, setCalificadora] = useState("");
  const [ultimo_pago, setUltimoPago] = useState("");
  const [forma_pago, setFormaPago] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaEdit, setSelectedAreaEdit] = useState("");
  const [plazo, setPlazo] = useState("");
  const [porcentajePlazo1, setPorcentajePlazo1] = useState(100);
  const [plazo2, setPlazo2] = useState(0);
  const [porcentajePlazo2, setPorcentajePlazo2] = useState(0);
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [alertasVentas, setAlertasVentas] = useState("");
  const [alertasEdoCta, setAlertasEdoCta] = useState("");
  const [alertasMarketing, setAlertasMarketing] = useState("");
  const [listaPrecios, setListaPrecios] = useState(1);
  const [requiereFactura, setRequiereFactura] = useState("No");
  const [empresasList, setEmpresasList] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  // Info
  const [idInfo, setIdInfo] = useState("");
  const [telefono_info, setTelefonoInfo] = useState("");
  const [nombre_comercial_info, setNombreComercialInfo] = useState("");
  const [email_info, setEmailInfo] = useState("");
  const [forma_pago_info, setFormaPagoInfo] = useState("");
  const [razon_social_info, setRazonSocialInfo] = useState("");
  const [grupo_info, setGruposInfo] = useState("");
  const [direccion_info, setDireccionInfo] = useState("");
  const [colaborador_info, setColaboradorInfo] = useState("");
  const [observaciones_info, setObservacionesInfo] = useState("");

  // Datos Facturacion
  const URL_DATOS_FACTURACION = process.env.REACT_APP_URL_DATOS_FACTURACION;
  const [AbrirEditarDF, setAbrirEditarDF] = useState(false);
  const [idClienteDF, setIdClienteDF] = useState("");
  const [nombreComercialDF, setNombreComercialDF] = useState("");
  const [datosFacturacion, setDatosFacturacion] = useState([]);
  const [inputFieldsDF, setInputFieldsDF] = useState([]);

  function dirDF(id, nombre_comercial) {
    setIdClienteDF(id);
    setNombreComercialDF(nombre_comercial);
    axios
      .get(`${URL_DATOS_FACTURACION}Cliente/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setDatosFacturacion(res.data || []);
        setInputFieldsDF([]);
        setAbrirEditarDF(true);
      })
      .catch((err) => {
        console.log(err);
        setAbrirEditarDF(true);
      });
  }

  const handleChangeDFExistente = (id, event) => {
    setDatosFacturacion(
      datosFacturacion.map((i) =>
        id === i._id ? { ...i, [event.target.name]: event.target.value } : i
      )
    );
  };
  const handleChangeDFNuevo = (id, event) => {
    setInputFieldsDF(
      inputFieldsDF.map((i) =>
        id === i.id ? { ...i, [event.target.name]: event.target.value } : i
      )
    );
  };
  const handleAddDF = () => {
    setInputFieldsDF([
      ...inputFieldsDF,
      {
        id: uuidv4(),
        alias: "",
        razon_social: "",
        RFC: "",
        regFiscal: "",
        cp: "",
        email: "",
        usoCFDI: "S01",
        formaPagoSAT: "99",
        condicionesPagoSAT: "NA",
        metodoPagoSAT: "PPD",
      },
    ]);
  };
  const handleRemoveDF = (id) => {
    setInputFieldsDF(inputFieldsDF.filter((i) => i.id !== id));
  };

  function saveDatosFacturacion() {
    // Actualizar existentes
    const promesas = datosFacturacion
      .filter((d) => d.razon_social && d.RFC)
      .map((d) =>
        axios.patch(
          `${URL_DATOS_FACTURACION}/${d._id}`,
          {
            alias: d.alias || "",
            razon_social: d.razon_social,
            RFC: d.RFC,
            regFiscal: Number(d.regFiscal) || 0,
            cp: String(d.cp || ""),
            email: d.email || "",
            usoCFDI: d.usoCFDI || "S01",
            formaPagoSAT: d.formaPagoSAT || "99",
            condicionesPagoSAT: d.condicionesPagoSAT || "NA",
            metodoPagoSAT: d.metodoPagoSAT || "PPD",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      );

    // Crear nuevos
    inputFieldsDF
      .filter((d) => d.razon_social && d.RFC)
      .forEach((d) => {
        promesas.push(
          axios.post(
            URL_DATOS_FACTURACION,
            {
              clientes: idClienteDF,
              alias: d.alias || "",
              razon_social: d.razon_social,
              RFC: d.RFC,
              regFiscal: Number(d.regFiscal) || 0,
              cp: String(d.cp || ""),
              email: d.email || "",
              usoCFDI: d.usoCFDI || "S01",
              formaPagoSAT: d.formaPagoSAT || "99",
              condicionesPagoSAT: d.condicionesPagoSAT || "NA",
              metodoPagoSAT: d.metodoPagoSAT || "PPD",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        );
      });

    Promise.all(promesas)
      .then(() => {
        Swal.fire("Listo", "Datos de Facturación guardados", "success");
        setTimeout(() => window.location.reload(), 800);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar todo",
          footer: err?.response?.data?.message || err.message,
        });
      });
  }

  // Direcciones Sucursal
  const [sucursales, setSucursales] = useState([]);
  const [idClienteSucursal, setIdClienteSucursal] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalSucursal, setModalSucursal] = useState(false);
  const toggleSucursal = () => setModalSucursal(!modalSucursal);

  const [abrirSucursal, setAbrirSucursal] = useState(false);

  const [modalPassword, setModalPassword] = useState(false);
  const togglePassword = () => setModalPassword(!modalPassword);

  // Z2: fichas técnicas del cliente (archivos)
  const [modalFichaCliente, setModalFichaCliente] = useState(false);
  const toggleFichaCliente = () => setModalFichaCliente(!modalFichaCliente);
  const [idEditFichaCliente, setIdEditFichaCliente] = useState("");
  const [fichaArchivos, setFichaArchivos] = useState([]);
  const [fichaResources, setFichaResources] = useState([]);

  const [activo, setActivo] = useState("Si");
  const [vendedor, setVendedor] = useState("");
  const [departamentoFiltro, setDepartamentoFiltro] = useState("");
  const [almacenFiltro, setAlmacenFiltro] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("");
  const [grupo, setGrupo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      paqueteria: "",
      alias: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      delegacion: "",
      estado: "",
      pais: "",
      cp: "",
      colonia: "",
      ciudad: "",
      RFC: "",
      razon_social: "",
      regFiscal: "",
      email: "",
    },
  ]);

  useMemo(() => {
    if (user.areas) {
        axios
          .get(`${URL_CLIENTES}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allClientes = response.data;
            // Array para pagination
            let arrayTabla = allClientes
              .sort((a, b) =>
                a.nombre_comercial > b.nombre_comercial ? 1 : -1
              )
              .map((a) => {
                const gr = a.grupos?.[0] || {};
                const dp = a.departamentosClientes?.[0] || {};
                const vd = a.vendedor?.[0] || {};
                const ar = a.areas?.[0] || {};
                return {
                  _id: a._id,
                  activo: a.is_active,
                  telefono: a.telefono,
                  email: a.email,
                  calle: a.calle,
                  numero_ext: a.numero_ext,
                  numero_int: a.numero_int,
                  pais: a.pais,
                  estado: a.estado,
                  ciudad: a.ciudad,
                  delegacion: a.delegacion,
                  colonia: a.colonia,
                  codigo: a.codigo,
                  cp: a.cp,
                  nombre_comercial: a.nombre_comercial,
                  razon_social: a.razon_social,
                  RFC: a.RFC,
                  grupo: gr.name || "",
                  idGrupo: gr._id || "",
                  departamento: dp.name || "",
                  idDepartamento: dp._id || "",
                  vendedor: vd.nombre || vd.apellido
                    ? `${vd.nombre || ""} ${vd.apellido || ""}`.trim()
                    : "",
                  idVendedor: vd._id || "",
                  observaciones: a.observaciones,
                  calificadora: a.calificadora,
                  ultimo_pago: a.ultimo_pago,
                  forma_pago: a.forma_pago,
                  area: ar.name || "",
                  idArea: ar._id || "",
                  regFiscal: a.regFiscal,
                  usoCFDI: a.usoCFDI,
                  formaPagoSAT: a.formaPagoSAT,
                  condicionesPagoSAT: a.condicionesPagoSAT,
                  metodoPagoSAT: a.metodoPagoSAT,
                  fiscal: a.fiscal,
                  plazo: a.plazo,
                  porcentajePlazo1: a.porcentajePlazo1,
                  plazo2: a.plazo2,
                  porcentajePlazo2: a.porcentajePlazo2,
                  alertasVentas: a.alertasVentas,
                  alertasEdoCta: a.alertasEdoCta,
                  alertasMarketing: a.alertasMarketing,
                  ultimaVenta: a.ultimaVenta,
                  listaPrecios: a.listaPrecios,
                  empresa: a.empresas?.[0]?.name || "",
                  idEmpresa: a.empresas?.[0]?._id || "",
                  requiereFactura: a.requiereFactura || "No",
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            setComments(dataFinal);
            //
          })
          .catch((err) => {
            console.log(err);
          })
    }
    // axios
    //   .get(URL_GRUPOS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allGrupos = response.data;
    //     setGrupos(allGrupos);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_DEPARTAMENTOS_CLIENTES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allDepartamentos = res.data;
    //     setDepartamentos(allDepartamentos);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setEmpresasList(res.data || []))
      .catch((err) => console.log(err));
  }, [user, activo, almacenFiltro]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return [
          a.codigo,
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupo,
          a.vendedor,
          a.area,
          fechaUltimaVenta(a.ultimaVenta)
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Telefono",
          "Mail",
          "Grupo",
          "Vendedor",
          "Almacen",
          "Ultima Venta",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    abrePDF(doc, `Clientes.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return {
          Activo: a.activo,
          Codigo: a.codigo,
          Nombre: a.nombre_comercial,
          RazonSocial: a.razon_social,
          RFC: a.RFC,
          Calle: a.calle,
          NoExt: a.numero_ext,
          NoInt: a.numero_int,
          Pais: a.pais,
          Estado: a.estado,
          Ciudad: a.ciudad,
          Delegacion: a.delegacion,
          Colonia: a.colonia,
          CP: a.cp,
          Telefono: a.telefono,
          Mail: a.email,
          Vendedor: a.vendedor,
          FormaPago: a.forma_pago,
          Plazo: a.plazo,
          RegFiscal: a.regFiscal,
          Grupo: a.grupo,
          Departamento: a.departamento,
          Almacen: a.area,
          Observaciones: a.observaciones,
          UltimaVenta: fechaUltimaVenta(a.ultimaVenta),
          ListaPrecios: a.listaPrecios,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoClientes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoClientes",
        sheetFilter: [
          "Activo",
          "Codigo",
          "Nombre",
          "RazonSocial",
          "RFC",
          "Calle",
          "NoExt",
          "NoInt",
          "Pais",
          "Estado",
          "Ciudad",
          "Delegacion",
          "Colonia",
          "CP",
          "Telefono",
          "Mail",
          "Vendedor",
          "FormaPago",
          "Plazo",
          "RegFiscal",
          "Grupo",
          "Departamento",
          "Almacen",
          "Observaciones",
          "UltimaVenta",
          "ListaPrecios",
        ],
        sheetHeader: [
          "Activo",
          "Codigo",
          "Nombre",
          "RazonSocial",
          "RFC",
          "Calle",
          "NoExt",
          "NoInt",
          "Pais",
          "Estado",
          "Ciudad",
          "Delegacion",
          "Colonia",
          "CP",
          "Telefono",
          "Mail",
          "Vendedor",
          "FormaPago",
          "Plazo",
          "RegFiscal",
          "Grupo",
          "Departamento",
          "Almacen",
          "Observaciones",
          "UltimaVenta",
          "ListaPrecios",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  // C14: Bajar/Subir BD para Clientes + DatosFacturacion + Sucursales
  // Sigue el mismo patrón que ListadoArticulos (descargar/subir Base):
  // se descarga un XLSX con 3 hojas y al subirlo se hace PATCH por _id en
  // cada hoja hacia su endpoint correspondiente.
  const CAMPOS_CLIENTES = [
    "_id", "codigo", "nombre_comercial", "razon_social", "RFC",
    "calle", "numero_ext", "numero_int", "delegacion", "colonia",
    "ciudad", "estado", "pais", "cp", "telefono", "email",
    "forma_pago", "ultimo_pago", "observaciones",
    "regFiscal", "usoCFDI", "formaPagoSAT", "condicionesPagoSAT", "metodoPagoSAT",
    "fiscal", "requiereFactura",
    "calificadora", "plazo", "porcentajePlazo1", "plazo2", "porcentajePlazo2",
    "listaPrecios", "is_active",
  ];
  const CAMPOS_DATOSFACT = [
    "_id", "clientes", "alias", "razon_social", "RFC", "regFiscal",
    "cp", "email", "usoCFDI", "formaPagoSAT", "condicionesPagoSAT",
    "metodoPagoSAT", "is_active",
  ];
  const CAMPOS_SUCURSALES = [
    "_id", "clientes", "alias", "responsable", "calle", "numero_ext",
    "numero_int", "colonia", "delegacion", "ciudad", "estado", "pais",
    "cp", "razon_social", "RFC", "regFiscal", "paqueteria", "email",
    "is_active",
  ];

  async function descargarBaseClientes() {
    try {
      Swal.fire({
        title: "Preparando descarga...",
        html: "Bajando Clientes, DatosFacturacion y Sucursales",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });
      const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
      const [rClientes, rDatos, rSuc] = await Promise.all([
        axios.get(URL_CLIENTES, { headers }),
        axios.get(URL_DATOS_FACTURACION, { headers }),
        axios.get(URL_SUCURSALES, { headers }),
      ]);
      // El primer id de `clientes[]` es referencia (no editable) para saber
      // a qué cliente pertenece la fila cuando se re-suba el Excel.
      const primerIdCliente = (arr) => {
        if (!Array.isArray(arr) || !arr.length) return "";
        const c = arr[0];
        return typeof c === "string" ? c : (c?._id || "");
      };
      const rowsC = (rClientes.data || []).map((a) => {
        const r = {};
        for (const k of CAMPOS_CLIENTES) r[k] = a[k] == null ? "" : a[k];
        return r;
      });
      const rowsD = (rDatos.data || []).map((a) => {
        const r = {};
        for (const k of CAMPOS_DATOSFACT) {
          if (k === "clientes") r[k] = primerIdCliente(a.clientes);
          else r[k] = a[k] == null ? "" : a[k];
        }
        return r;
      });
      const rowsS = (rSuc.data || []).map((a) => {
        const r = {};
        for (const k of CAMPOS_SUCURSALES) {
          if (k === "clientes") r[k] = primerIdCliente(a.clientes);
          else r[k] = a[k] == null ? "" : a[k];
        }
        return r;
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rowsC), "Clientes");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rowsD), "DatosFacturacion");
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rowsS), "Sucursales");
      const hoy = new Date().toISOString().slice(0, 10);
      Swal.close();
      XLSX.writeFile(wb, `Clientes-BD-${hoy}.xlsx`);
    } catch (err) {
      console.error("[BajarBDClientes]", err);
      Swal.close();
      Swal.fire({ icon: "error", title: "Error al descargar", text: err?.message || "error" });
    }
  }

  async function subirBaseClientes(event) {
    const target = event.target;
    if (target.name !== "fileBaseClientes") return;
    if (!target.files || !target.files[0]) return;
    const confirm = await Swal.fire({
      title: "¿Actualizar la base?",
      html: "Se hará PATCH por <b>_id</b> sobre cada fila en las hojas <b>Clientes</b>, <b>DatosFacturacion</b> y <b>Sucursales</b>.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, actualizar",
    });
    if (!confirm.isConfirmed) { target.value = ""; return; }
    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const readSheet = (name) => {
        const s = workbook.Sheets[name];
        return s ? XLSX.utils.sheet_to_json(s) : [];
      };
      const filasClientes = readSheet("Clientes");
      const filasDatos = readSheet("DatosFacturacion");
      const filasSuc = readSheet("Sucursales");
      const total = filasClientes.length + filasDatos.length + filasSuc.length;
      let procesados = 0;
      let ok = 0;
      const errores = [];
      const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
      Swal.fire({
        title: "Estamos trabajando...",
        html: `Actualizando base de clientes<br/><b id="swal-subirbd-cli">0 / ${total} filas</b>`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });
      const updateProgress = () => {
        const el = document.getElementById("swal-subirbd-cli");
        if (el) el.textContent = `${procesados} / ${total} filas`;
      };

      // Helper genérico: recorre las filas de una hoja y hace PATCH al endpoint
      const patchear = async (filas, campos, urlBase, tag) => {
        for (const r of filas) {
          const id = String(r._id || "").trim();
          if (!id) { errores.push(`${tag}: fila sin _id`); procesados++; updateProgress(); continue; }
          const payload = {};
          for (const k of campos) {
            if (k === "_id") continue;
            if (r[k] !== undefined && r[k] !== "" && r[k] !== null) {
              payload[k] = r[k];
            }
          }
          if (!Object.keys(payload).length) { procesados++; updateProgress(); continue; }
          try {
            await axios.patch(`${urlBase}/${id}`, payload, { headers });
            ok++;
          } catch (err) {
            const msg = err?.response?.data?.validation?.body?.message
              || err?.response?.data?.message
              || err?.message
              || "error";
            console.error(`[SubirBDClientes ${tag}] FAIL ${id}:`, msg, err?.response?.data, "payload:", payload);
            errores.push(`${tag} ${id}: ${msg}`);
          }
          procesados++;
          updateProgress();
        }
      };

      await patchear(filasClientes, CAMPOS_CLIENTES, URL_CLIENTES, "Cliente");
      await patchear(filasDatos, CAMPOS_DATOSFACT, URL_DATOS_FACTURACION, "DatosFact");
      await patchear(filasSuc, CAMPOS_SUCURSALES, URL_SUCURSALES, "Sucursal");

      Swal.close();
      Swal.fire({
        icon: errores.length ? "warning" : "success",
        title: "Base actualizada",
        html: `${ok} filas actualizadas. ${errores.length} errores.` +
          (errores.length ? `<br/><br/><small style="text-align:left;display:block;">${errores.slice(0, 5).join("<br/>")}${errores.length > 5 ? `<br/>… y ${errores.length - 5} más` : ""}</small>` : ""),
      }).then(() => window.location.reload());
    };
    target.value = "";
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return [
          a.codigo,
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupo,
          a.vendedor,
          a.area,
          fechaUltimaVenta(a.ultimaVenta)
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Telefono",
          "Mail",
          "Grupo",
          "Vendedor",
          "Almacen",
          "Ultima Venta",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    telefono,
    email,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    nombre_comercial,
    razon_social,
    RFC,
    // gruposId,
    vendedorNombre,
    vendedorId,
    observaciones,
    calificadora,
    ultimo_pago,
    forma_pago,
    codigo,
    departamentoId,
    idArea,
    plazo,
     usoCFDI, 
    regFiscal, 
    formaPagoSAT,
    condicionesPagoSAT,
    metodoPagoSAT,
    alertasVentas,
    alertasEdoCta,
    alertasMarketing,
    listaPrecios
  ) {
    setTelefono(telefono);
    setEmail(email);
    setEmailViejo(email);
    setCalle(calle);
    setNumeroExt(numero_ext);
    setNumeroInt(numero_int);
    setPais(pais);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCP(cp);
    setNombreComercial(nombre_comercial);
    setRazonSocial(razon_social);
    setRFC(RFC);
    // setSelectedGrupoEdit(gruposId);
    setSelectedDepartamentoEdit(departamentoId);
    setSelectedVendedorName(vendedorNombre);
    setSelectedVendedor(vendedorId);
    setObservaciones(observaciones);
    setCalificadora(calificadora);
    setUltimoPago(ultimo_pago);
    setFormaPago(forma_pago);
    setCodigo(codigo);
    setIdEditCliente(idEdit);
    setSelectedAreaEdit(idArea);
    setPlazo(plazo);
    setusoCFDI(usoCFDI)
    setRegFiscal(regFiscal)
    setFormaPagoSAT(formaPagoSAT);
    setCondicionesPagoSAT(condicionesPagoSAT);
    setMetodoPagoSAT(metodoPagoSAT);
    setAlertasVentas(alertasVentas)
    setAlertasEdoCta(alertasEdoCta)
    setAlertasMarketing(alertasMarketing)
    setListaPrecios(listaPrecios)
    // Plazos duales y empresa/categoria (no estan en los args de jalaInfo, los traemos del row)
    const row = (comments || []).find((c) => c._id === idEdit);
    if (row) {
      setPorcentajePlazo1(row.porcentajePlazo1 != null ? row.porcentajePlazo1 : 100);
      setPlazo2(row.plazo2 || 0);
      setPorcentajePlazo2(row.porcentajePlazo2 || 0);
      setSelectedEmpresa(row.idEmpresa || "");
      setRequiereFactura(row.requiereFactura || "No");
    } else {
      setPorcentajePlazo1(100);
      setPlazo2(0);
      setPorcentajePlazo2(0);
      setSelectedEmpresa("");
      setRequiereFactura("No");
    }
    toggleEdit();
  }

  function Info(
    id,
    nombre_comercial,
    telefono,
    email,
    forma_pago,
    razon_social,
    // grupos,
    calle,
    numero_ext,
    numero_int,
    colonia,
    colaboradoresName,
    observaciones
  ) {
    setIdInfo(id);
    setNombreComercialInfo(nombre_comercial);
    setTelefonoInfo(telefono);
    setEmailInfo(email);
    setFormaPagoInfo(forma_pago);
    setRazonSocialInfo(razon_social);
    // setGruposInfo(grupos);
    setDireccionInfo(
      calle + " " + numero_ext + " " + numero_int + " " + colonia
    );
    setColaboradorInfo(colaboradoresName);
    setObservacionesInfo(observaciones);
    toggle();
  }

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEditCliente}`;
        axios.patch(
          URL_CLIENTES_EDIT,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            email,
            // grupos: selectedGrupoEdit,
            // departamentosClientes: selectedDepartamentoEdit,
            vendedor: selectedVendedor,
            observaciones,
            calificadora,
            ultimo_pago,
            forma_pago,
            codigo,
            areas: selectedAreaEdit,
            plazo,
            porcentajePlazo1: Number(porcentajePlazo1) || 100,
            plazo2: Number(plazo2) || 0,
            porcentajePlazo2: Number(porcentajePlazo2) || 0,
            empresas: selectedEmpresa || null,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            alertasVentas,
            alertasEdoCta,
            alertasMarketing,
            listaPrecios,
            requiereFactura
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Estado", field: "estado", sortable: true },
    { name: "Telefono", field: "telefono", sortable: false },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Lista Precios", field: "listaPrecios", sortable: false },
    { name: "Calificadora", field: "calificadora", sortable: true },
    { name: "Ult Venta", field: "ultimaVenta", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  // ultimaVenta se guarda YYYY-MM-DD (la fija el back al autorizar el surtido
  // de un pedido y al crear una nota). "2000-01-01" es el default del modelo
  // = nunca ha comprado; null/ausente en clientes viejos.
  function fechaUltimaVenta(v) {
    if (!v || v === "2000-01-01") return "—";
    return fDMA(v);
  }

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.departamento.toLowerCase().includes(search.toLowerCase()) ||
          comment.grupo.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.estado.toLowerCase().includes(search.toLowerCase()) ||
          comment.calificadora.toString().includes(search)||
          comment.listaPrecios.toString().includes(search)
      );
    }
    if (grupo) {
      computedComments = computedComments.filter((e) =>
        e.idGrupo.includes(grupo)
      );
    }
    if (vendedor) {
      computedComments = computedComments.filter((e) =>
        e.idVendedor.includes(vendedor)
      );
    }
    if (departamentoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idDepartamento.includes(departamentoFiltro)
      );
    }
    if (almacenFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(almacenFiltro)
      );
    }
    if (estadoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.estado.includes(estadoFiltro)
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field && sorting.field != "calificadora") {
      const reversed = sorting.order === "asc" ? 1 : -1;
      // null-safe: hay clientes sin ultimaVenta (o con otros campos vacíos)
      computedComments = computedComments.sort(
        (a, b) =>
          reversed *
          String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      sorting.field == "calificadora"
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      sorting.field == "calificadora"
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    vendedor,
    grupo,
    departamentoFiltro,
    almacenFiltro,
    estadoFiltro,
    selectedArea,
  ]);

  function dir(id, nombre_comercial) {
    setIdClienteSucursal(id);
    setNombreComercial(nombre_comercial);
    axios
      .get(`${URL_SUCURSALES}/clientes/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
    setAbrirSucursal(true);
  }

  const handleChangeInputExistentes = (id, event) => {
    const newSucursales = sucursales.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setSucursales(newSucursales);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function saveDireccion() {
    let totalDir = sucursales.length + inputFields.length;
    sucursales.map((a) => {
      if (a.alias != "") {
        axios
          .patch(
            `${URL_SUCURSALES}/${a._id}`,
            {
              paqueteria: a.paqueteria,
              alias: a.alias,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              delegacion: a.delegacion,
              estado: a.estado,
              pais: a.pais,
              cp: a.cp,
              colonia: a.colonia,
              ciudad: a.ciudad,
              RFC: a.RFC,
              razon_social: a.razon_social,
              regFiscal: a.regFiscal,
              email: a.email,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalDir = totalDir - 1;
            if (totalDir == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Sucursal",
                  detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalDir = totalDir - 1;
      }
    });

    // agregar inputFields
    inputFields.map((a) => {
      if (a.alias != "") {
        axios
          .post(
            `${URL_SUCURSALES}`,
            {
              paqueteria: a.paqueteria,
              alias: a.alias,
              calle: a.calle,
              numero_ext: a.numero_ext,
              numero_int: a.numero_int,
              delegacion: a.delegacion,
              estado: a.estado,
              pais: a.pais,
              cp: a.cp,
              colonia: a.colonia,
              ciudad: a.ciudad,
              clientes: idClienteSucursal,
              RFC: a.RFC,
              razon_social: a.razon_social,
              regFiscal: a.regFiscal,
              email: a.email,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalDir = totalDir - 1;
            if (totalDir == 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Editar Sucursal",
                  detalle: `Cliente ${idClienteSucursal} / Alias ${a.alias}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", `success`);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } else {
        totalDir = totalDir - 1;
      }
    });
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        paqueteria: "",
        alias: "",
        calle: "",
        numero_ext: "",
        numero_int: "",
        delegacion: "",
        estado: "",
        pais: "",
        cp: "",
        colonia: "",
        ciudad: "",
        RFC: "",
        razon_social: "",
        regFiscal: "",
        email: "",
        usoCFDI: "S01",
        formaPagoSAT: "99",
        condicionesPagoSAT: "NA",
        metodoPagoSAT: "PPD",
      },
    ]);
  };

  // Z2: helpers para fichas de cliente (Cloudinary)
  function jalaFichasCliente(idCliente) {
    setFichaArchivos([]);
    setFichaResources([]);
    setIdEditFichaCliente(idCliente);
    const URL_GET = (process.env.REACT_APP_URL_GETMEDIA || "")
      .replace(/findonemedia\/?$/, `findFichasCliente/${idCliente}`);
    axios
      .get(URL_GET, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const lista = Array.isArray(res.data?.resources) ? res.data.resources : [];
        setFichaResources(
          lista
            .map((r) => ({ url: r.secure_url || r.url || "", public_id: r.public_id || "" }))
            .filter((r) => r.url)
        );
      })
      .catch((err) => console.log(err));
    toggleFichaCliente();
  }

  async function subirFichasCliente() {
    if (!fichaArchivos.length) {
      Swal.fire({ icon: "warning", title: "Selecciona archivos" });
      return;
    }
    const URL_UP = (process.env.REACT_APP_URL_GETMEDIA || "")
      .replace(/findonemedia\/?$/, "upFichaCliente");
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const uploads = [];
    for (let i = 0; i < fichaArchivos.length; i++) {
      const archivo = fichaArchivos[i];
      const fd = new FormData();
      const safeName = String(archivo.name || `file-${i}`).replace(/[^\w.-]/g, "_");
      const publicId = `macuroClientesFicha/${idEditFichaCliente}/${Date.now()}-${i}-${safeName}`;
      fd.append("file", archivo);
      fd.append("cliente", idEditFichaCliente);
      fd.append("public_id", publicId);
      uploads.push(axios.post(URL_UP, fd, { headers }));
    }
    try {
      await Promise.all(uploads);
      setFichaArchivos([]);
      Swal.fire({ icon: "success", title: "Subido", timer: 1200, showConfirmButton: false });
      jalaFichasCliente(idEditFichaCliente);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error al subir", text: err?.response?.data?.message || err.message });
    }
  }

  function eliminarFichaCliente(publicId) {
    if (!publicId) return;
    Swal.fire({
      title: "¿Eliminar archivo?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const URL_DEL = (process.env.REACT_APP_URL_GETMEDIA || "")
        .replace(/findonemedia\/?$/, "delFichaCliente");
      try {
        await axios.delete(URL_DEL, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          data: { public_id: publicId },
        });
        Swal.fire({ icon: "success", title: "Eliminada", timer: 1000, showConfirmButton: false });
        jalaFichasCliente(idEditFichaCliente);
      } catch (err) {
        Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err.message });
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_clientes ? (
        <div className="card col-12">
              <Row>
                <Col md={8}>
                  {user.clientes_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/ClientesCreate"
                    >
                      Nuevo Cliente
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Cliente
                    </Button>
                  )}
                  {/* <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
                </Col>
                <Col sm={4}>
                  <input
                    id="fileBaseClientesHidden"
                    name="fileBaseClientes"
                    type="file"
                    accept=".xlsx,.xls"
                    style={{ display: "none" }}
                    onChange={subirBaseClientes}
                  />
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                    {/* C14: descargar/subir toda la base de clientes (3 hojas) */}
                    <Button
                      size="sm"
                      color="success"
                      onClick={descargarBaseClientes}
                      title="Descarga clientes + datosFacturacion + sucursales en un Excel de 3 hojas"
                    >
                      Bajar BD
                    </Button>
                    <Button
                      size="sm"
                      color="warning"
                      onClick={() => document.getElementById("fileBaseClientesHidden").click()}
                      title="Sube el mismo Excel para actualizar las 3 colecciones (PATCH por _id)"
                    >
                      Subir BD
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Clientes</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Clientes</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <Row>
                {user.areas == AREAS_GENERAL ? (
                  <Col md={2}>
                    <Label>Almacen</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={almacenFiltro}
                      onChange={(e) => {
                        setAlmacenFiltro(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                ) : undefined}
                <Col md={2}>
                  <Label>Estado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={estadoFiltro}
                    onChange={(e) => {
                      setEstadoFiltro(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                    <option value="BAJA CALIFORNIA NORTE">
                      BAJA CALIFORNIA NORTE
                    </option>
                    <option value="BAJA CALIFORNIA SUR">
                      BAJA CALIFORNIA SUR
                    </option>
                    <option value="CAMPECHE">CAMPECHE</option>
                    <option value="CHIAPAS">CHIAPAS</option>
                    <option value="CHIHUAHUA">CHIHUAHUA</option>
                    <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                    <option value="COAHUILA">COAHUILA</option>
                    <option value="COLIMA">COLIMA</option>
                    <option value="DURANGO">DURANGO</option>
                    <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                    <option value="GUANAJUATO">GUANAJUATO</option>
                    <option value="GUERRERO">GUERRERO</option>
                    <option value="HIDALGO">HIDALGO</option>
                    <option value="JALISCO">JALISCO</option>
                    <option value="MICHOACAN">MICHOACAN</option>
                    <option value="MORELOS">MORELOS</option>
                    <option value="NAYARIT">NAYARIT</option>
                    <option value="NUEVO LEON">NUEVO LEON</option>
                    <option value="OAXACA">OAXACA</option>
                    <option value="PUEBLA">PUEBLA</option>
                    <option value="QUERETARO">QUERETARO</option>
                    <option value="QUINTANA ROO">QUINTANA ROO</option>
                    <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                    <option value="SINALOA">SINALOA</option>
                    <option value="SONORA">SONORA</option>
                    <option value="TABASCO">TABASCO</option>
                    <option value="TAMAULIPAS">TAMAULIPAS</option>
                    <option value="TLAXCALA">TLAXCALA</option>
                    <option value="VERACRUZ">VERACRUZ</option>
                    <option value="YUCATAN">YUCATAN</option>
                    <option value="ZACATECAS">ZACATECAS</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Vendedor</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={vendedor}
                    onChange={(e) => {
                      setVendedor(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colaboradores
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        // if (a.cobrador == "Si") {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                        // }
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Activo</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={activo}
                    required
                    onChange={(e) => {
                      setActivo(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData.map((p) => {
                    {
                      return (
                        <tr>
                          <td>{p.codigo}</td>
                          <td> {p.nombre_comercial}</td>
                          <td> {p.estado}</td>
                          <td>{p.telefono}</td>
                          <td>{p.area}</td>
                          <td>{p.vendedor}</td>
                          <td>{p.listaPrecios}</td>
                          <td>
                            {p.calificadora == 1 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 2 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 3 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 4 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 5 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : undefined}
                          </td>
                          <td>{fechaUltimaVenta(p.ultimaVenta)}</td>
                          <td>
                            {user.clientes_create ? (
                              <div>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  title="Sucursales (direcciones de envío)"
                                  onClick={(e) =>
                                    dir(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-shipping-fast"></i>
                                </Button>
                                <Button
                                  color="warning"
                                  size="sm"
                                  title="Datos de Facturación (razones sociales / RFC alternos)"
                                  onClick={(e) =>
                                    dirDF(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-file-invoice-dollar"></i>
                                </Button>
                                <Button
                                  color="secondary"
                                  size="sm"
                                  title="Fichas / Archivos del cliente"
                                  onClick={(e) => jalaFichasCliente(p._id)}
                                >
                                  <i class="fas fa-paperclip"></i>
                                </Button>
                                {/* <Button
                                  color="success"
                                  size="sm"
                                  onClick={(e) =>
                                    Info(
                                      p._id,
                                      p.nombre_comercial,
                                      p.telefono,
                                      p.email,
                                      p.forma_pago,
                                      p.razon_social,
                                      p.grupo,
                                      p.calle,
                                      p.numero_ext,
                                      p.numero_int,
                                      p.colonia,
                                      p.vendedor,
                                      p.observaciones
                                    )
                                  }
                                  id="Detalle"
                                >
                                  <i class="fas fa-file-alt"></i>
                                </Button> */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    jalaInfo(
                                      p._id,
                                      p.telefono,
                                      p.email,
                                      p.calle,
                                      p.numero_ext,
                                      p.numero_int,
                                      p.pais,
                                      p.estado,
                                      p.ciudad,
                                      p.delegacion,
                                      p.colonia,
                                      p.cp,
                                      p.nombre_comercial,
                                      p.razon_social,
                                      p.RFC,
                                      // p.idGrupo,
                                      p.vendedor,
                                      p.idVendedor,
                                      p.observaciones,
                                      p.calificadora,
                                      p.ultimo_pago,
                                      p.forma_pago,
                                      p.codigo,
                                      p.idDepartamento,
                                      p.idArea,
                                      p.plazo,
                                       p.usoCFDI, 
                                      p.regFiscal,
                                      p.formaPagoSAT,
                                      p.condicionesPagoSAT,
                                      p.metodoPagoSAT,
                                      p.alertasVentas,
                                      p.alertasEdoCta,
                                      p.alertasMarketing,
                                      p.listaPrecios
                                    )
                                  }
                                >
                                  <i class="far fa-edit"></i>
                                </Button>
                                {/* <Button
                              color="success"
                              id="Password"
                              size="sm"
                              onClick={(e) => jalaInfoPassword(p._id)}
                            >
                              <i class="fas fa-user-lock"></i>
                            </Button> */}
                                <Baja
                                  idStatus={p._id}
                                  is_active={p.activo}
                                  URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                                />
                              </div>
                            ) : (
                              <div>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="far fa-edit"></i>
                                </Button>
                                <Button
                                  color="success"
                                  id="Password"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-user-lock"></i>
                                </Button>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
          <Modal size="xl" isOpen={abrirSucursal} toggle={() => setAbrirSucursal(!abrirSucursal)}>
            <ModalHeader toggle={() => setAbrirSucursal(!abrirSucursal)}>
              <h4><i className="fas fa-store"></i> Sucursales — {nombre_comercial}</h4>
            </ModalHeader>
            <ModalBody>
              <small style={{ color: "#666" }}>
                Aquí puedes registrar las sucursales del cliente con su dirección y datos fiscales (útil para entregas y facturación por sucursal).
              </small>
              <br /><br />
            <div className="card container col-md-12">
              {sucursales.map((ao) => (
                <div key={ao._id} style={{ borderBottom: "1px solid #eee", padding: 6 }}>
                  <Row>
                    <Col md={3}>
                      <Label>Alias</Label>
                      <Input
                        name="alias"
                        type="text"
                        value={ao.alias}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={4}>
                      <Label>Razon Social</Label>
                      <Input
                        name="razon_social"
                        type="text"
                        value={ao.razon_social}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>RFC</Label>
                      <Input
                        name="RFC"
                        type="text"
                        value={ao.RFC}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Reg Fiscal</Label>
                      <Input
                        name="regFiscal"
                        type="select"
                        value={ao.regFiscal}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      >
                        <option value="">Reg Fiscal</option>
                        <option value="0">0</option>
                        <option value="601">601 General de Ley Personas Morales</option>
                        <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                        <option value="605">605 Sueldos y Salarios</option>
                        <option value="608">608 Demas Ingresos</option>
                        <option value="612">612 PF Actividades Empresariales</option>
                        <option value="616">616 Sin Obligacion Fiscal</option>
                        <option value="621">621 Incorporacion Fiscal</option>
                        <option value="624">624 Regimen de los Coordinados</option>
                        <option value="625">625 Plataformas tecnologicas</option>
                        <option value="626">626 RESICO</option>
                      </Input>
                    </Col>
                    <Col md={1}>
                      <Label>Estado</Label>
                      <Baja
                        idStatus={ao._id}
                        is_active={ao.is_active}
                        URL_BAJA={process.env.REACT_APP_URL_SUCURSALES}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Label>Calle</Label>
                      <Input
                        name="calle"
                        type="text"
                        value={ao.calle}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label># Ext</Label>
                      <Input
                        name="numero_ext"
                        type="text"
                        value={ao.numero_ext}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label># Int</Label>
                      <Input
                        name="numero_int"
                        type="text"
                        value={ao.numero_int}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Colonia</Label>
                      <Input
                        name="colonia"
                        type="text"
                        value={ao.colonia}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Delegacion</Label>
                      <Input
                        name="delegacion"
                        type="text"
                        value={ao.delegacion}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <Label>Pais</Label>
                      <Input
                        name="pais"
                        type="text"
                        value={ao.pais}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Estado</Label>
                      <Input
                        type="select"
                        name="estado"
                        value={ao.estado}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      >
                        <option value="">Selecciona</option>
                        <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                        <option value="BAJA CALIFORNIA NORTE">BAJA CALIFORNIA NORTE</option>
                        <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                        <option value="CAMPECHE">CAMPECHE</option>
                        <option value="CHIAPAS">CHIAPAS</option>
                        <option value="CHIHUAHUA">CHIHUAHUA</option>
                        <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                        <option value="COAHUILA">COAHUILA</option>
                        <option value="COLIMA">COLIMA</option>
                        <option value="DURANGO">DURANGO</option>
                        <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                        <option value="GUANAJUATO">GUANAJUATO</option>
                        <option value="GUERRERO">GUERRERO</option>
                        <option value="HIDALGO">HIDALGO</option>
                        <option value="JALISCO">JALISCO</option>
                        <option value="MICHOACAN">MICHOACAN</option>
                        <option value="MORELOS">MORELOS</option>
                        <option value="NAYARIT">NAYARIT</option>
                        <option value="NUEVO LEON">NUEVO LEON</option>
                        <option value="OAXACA">OAXACA</option>
                        <option value="PUEBLA">PUEBLA</option>
                        <option value="QUERETARO">QUERETARO</option>
                        <option value="QUINTANA ROO">QUINTANA ROO</option>
                        <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                        <option value="SINALOA">SINALOA</option>
                        <option value="SONORA">SONORA</option>
                        <option value="TABASCO">TABASCO</option>
                        <option value="TAMAULIPAS">TAMAULIPAS</option>
                        <option value="TLAXCALA">TLAXCALA</option>
                        <option value="VERACRUZ">VERACRUZ</option>
                        <option value="YUCATAN">YUCATAN</option>
                        <option value="ZACATECAS">ZACATECAS</option>
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Label>Ciudad</Label>
                      <Input
                        name="ciudad"
                        type="text"
                        value={ao.ciudad}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label>CP</Label>
                      <Input
                        name="cp"
                        type="text"
                        value={ao.cp}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Paqueteria</Label>
                      <Input
                        name="paqueteria"
                        type="text"
                        value={ao.paqueteria}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Email</Label>
                      <Input
                        name="email"
                        type="email"
                        value={ao.email}
                        required
                        onChange={(e) => handleChangeInputExistentes(ao._id, e)}
                      />
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Agregar mas direcciones */}

              {inputFields.map((inputField) => (
                <div key={inputField.id} style={{ background: "#f7f7f7", borderRadius: 4, padding: 6, marginTop: 6 }}>
                  <Row>
                    <Col md={3}>
                      <Label>Alias</Label>
                      <Input
                        name="alias"
                        type="text"
                        value={inputField.alias}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={4}>
                      <Label>Razon Social</Label>
                      <Input
                        name="razon_social"
                        type="text"
                        value={inputField.razon_social}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>RFC</Label>
                      <Input
                        name="RFC"
                        type="text"
                        value={inputField.RFC}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Reg Fiscal</Label>
                      <Input
                        name="regFiscal"
                        type="select"
                        value={inputField.regFiscal}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      >
                        <option value="">Reg Fiscal</option>
                        <option value="0">0</option>
                        <option value="601">601 General de Ley Personas Morales</option>
                        <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                        <option value="605">605 Sueldos y Salarios</option>
                        <option value="608">608 Demas Ingresos</option>
                        <option value="612">612 PF Actividades Empresariales</option>
                        <option value="616">616 Sin Obligacion Fiscal</option>
                        <option value="621">621 Incorporacion Fiscal</option>
                        <option value="624">624 Regimen de los Coordinados</option>
                        <option value="625">625 Plataformas tecnologicas</option>
                        <option value="626">626 RESICO</option>
                      </Input>
                    </Col>
                    <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFields}
                        tabindex="-1"
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <Label>Calle</Label>
                      <Input
                        name="calle"
                        type="text"
                        value={inputField.calle}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label># Ext</Label>
                      <Input
                        name="numero_ext"
                        type="text"
                        value={inputField.numero_ext}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label># Int</Label>
                      <Input
                        name="numero_int"
                        type="text"
                        value={inputField.numero_int}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Colonia</Label>
                      <Input
                        name="colonia"
                        type="text"
                        value={inputField.colonia}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Delegacion</Label>
                      <Input
                        name="delegacion"
                        type="text"
                        value={inputField.delegacion}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <Label>Pais</Label>
                      <Input
                        name="pais"
                        type="text"
                        value={inputField.pais}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Estado</Label>
                      <Input
                        type="select"
                        name="estado"
                        value={inputField.estado}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      >
                        <option value="">Selecciona</option>
                        <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                        <option value="BAJA CALIFORNIA NORTE">BAJA CALIFORNIA NORTE</option>
                        <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                        <option value="CAMPECHE">CAMPECHE</option>
                        <option value="CHIAPAS">CHIAPAS</option>
                        <option value="CHIHUAHUA">CHIHUAHUA</option>
                        <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                        <option value="COAHUILA">COAHUILA</option>
                        <option value="COLIMA">COLIMA</option>
                        <option value="DURANGO">DURANGO</option>
                        <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                        <option value="GUANAJUATO">GUANAJUATO</option>
                        <option value="GUERRERO">GUERRERO</option>
                        <option value="HIDALGO">HIDALGO</option>
                        <option value="JALISCO">JALISCO</option>
                        <option value="MICHOACAN">MICHOACAN</option>
                        <option value="MORELOS">MORELOS</option>
                        <option value="NAYARIT">NAYARIT</option>
                        <option value="NUEVO LEON">NUEVO LEON</option>
                        <option value="OAXACA">OAXACA</option>
                        <option value="PUEBLA">PUEBLA</option>
                        <option value="QUERETARO">QUERETARO</option>
                        <option value="QUINTANA ROO">QUINTANA ROO</option>
                        <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                        <option value="SINALOA">SINALOA</option>
                        <option value="SONORA">SONORA</option>
                        <option value="TABASCO">TABASCO</option>
                        <option value="TAMAULIPAS">TAMAULIPAS</option>
                        <option value="TLAXCALA">TLAXCALA</option>
                        <option value="VERACRUZ">VERACRUZ</option>
                        <option value="YUCATAN">YUCATAN</option>
                        <option value="ZACATECAS">ZACATECAS</option>
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Label>Ciudad</Label>
                      <Input
                        name="ciudad"
                        type="text"
                        value={inputField.ciudad}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={1}>
                      <Label>CP</Label>
                      <Input
                        name="cp"
                        type="text"
                        value={inputField.cp}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={2}>
                      <Label>Paqueteria</Label>
                      <Input
                        name="paqueteria"
                        type="text"
                        value={inputField.paqueteria}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Email</Label>
                      <Input
                        name="email"
                        type="email"
                        value={inputField.email}
                        required
                        onChange={(e) => handleChangeInput(inputField.id, e)}
                      />
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={saveDireccion}>
                Guardar
              </Button>
              <Button color="secondary" onClick={() => setAbrirSucursal(false)}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}
      <br />

      <Modal size="xl" isOpen={AbrirEditarDF} toggle={() => setAbrirEditarDF(!AbrirEditarDF)}>
        <ModalHeader toggle={() => setAbrirEditarDF(!AbrirEditarDF)}>
          <h4>
            <i className="fas fa-file-invoice-dollar"></i> Datos de Facturación — {nombreComercialDF}
          </h4>
        </ModalHeader>
        <ModalBody>
          <small style={{ color: "#666" }}>
            Aquí puedes registrar varias razones sociales / RFC alternos del mismo cliente
            (útil cuando facturas a una empresa distinta del cliente comercial).
          </small>
          <br /><br />
          {datosFacturacion.length === 0 && inputFieldsDF.length === 0 && (
            <div align="center" style={{ padding: 20, color: "#888" }}>
              Sin datos de facturación. Click en "Agregar" para crear uno.
            </div>
          )}

          {datosFacturacion.map((d) => (
            <div key={d._id} style={{ borderBottom: "1px solid #eee", padding: 6 }}>
              <Row>
                <Col md={3}>
                  <Label>Alias</Label>
                  <Input
                    name="alias"
                    type="text"
                    value={d.alias || ""}
                    placeholder="Razon social principal, Empresa SAT..."
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Razon Social</Label>
                  <Input
                    name="razon_social"
                    type="text"
                    value={d.razon_social || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
                <Col md={2}>
                  <Label>RFC</Label>
                  <Input
                    name="RFC"
                    type="text"
                    value={d.RFC || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
                <Col md={2}>
                  <Label>CP</Label>
                  <Input
                    name="cp"
                    type="text"
                    value={d.cp || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
                <Col md={1}>
                  <Label>Estado</Label>
                  <Baja
                    idStatus={d._id}
                    is_active={d.is_active}
                    URL_BAJA={URL_DATOS_FACTURACION}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Reg Fiscal</Label>
                  <Input
                    name="regFiscal"
                    type="select"
                    value={d.regFiscal || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="601">601 General de Ley Personas Morales</option>
                    <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                    <option value="605">605 Sueldos y Salarios</option>
                    <option value="608">608 Demas Ingresos</option>
                    <option value="612">612 PF Actividades Empresariales</option>
                    <option value="616">616 Sin Obligacion Fiscal</option>
                    <option value="621">621 Incorporacion Fiscal</option>
                    <option value="626">626 RESICO</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Uso CFDI</Label>
                  <Input
                    name="usoCFDI"
                    type="select"
                    value={d.usoCFDI || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="G01">G01 Adquisicion de mercancias</option>
                    <option value="G02">G02 Devoluciones, descuentos o bonificaciones</option>
                    <option value="G03">G03 Gastos en general</option>
                    <option value="I01">I01 Construcciones</option>
                    <option value="I02">I02 Mobiliario y equipo de oficina por inversiones</option>
                    <option value="I03">I03 Equipo de transporte</option>
                    <option value="I04">I04 Equipo de computo y accesorios</option>
                    <option value="I05">I05 Dados, troqueles, moldes, matrices y herramental</option>
                    <option value="I06">I06 Comunicaciones telefonicas</option>
                    <option value="I07">I07 Comunicaciones satelitales</option>
                    <option value="I08">I08 Otra maquinaria y equipo</option>
                    <option value="D01">D01 Honorarios medicos, dentales y gastos hospitalarios</option>
                    <option value="D02">D02 Gastos medicos por incapacidad o discapacidad</option>
                    <option value="D03">D03 Gastos funerales</option>
                    <option value="D04">D04 Donativos</option>
                    <option value="D05">D05 Intereses reales efectivamente pagados por creditos hipotecarios</option>
                    <option value="D06">D06 Aportaciones voluntarias al SAR</option>
                    <option value="D07">D07 Primas por seguros de gastos medicos</option>
                    <option value="D08">D08 Gastos de transportacion escolar obligatoria</option>
                    <option value="D09">D09 Depositos en cuentas para el ahorro, primas que tengan como base planes de pensiones</option>
                    <option value="D10">D10 Pagos por servicios educativos (colegiaturas)</option>
                    <option value="S01">S01 Sin efectos fiscales</option>
                    <option value="CP01">CP01 Pagos</option>
                    <option value="CN01">CN01 Nomina</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Forma Pago SAT</Label>
                  <Input
                    name="formaPagoSAT"
                    type="select"
                    value={d.formaPagoSAT || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="01">01 Efectivo</option>
                    <option value="02">02 Cheque nominativo</option>
                    <option value="03">03 Transferencia electronica de fondos</option>
                    <option value="04">04 Tarjeta de credito</option>
                    <option value="05">05 Monedero electronico</option>
                    <option value="06">06 Dinero electronico</option>
                    <option value="08">08 Vales de despensa</option>
                    <option value="12">12 Dacion en pago</option>
                    <option value="13">13 Pago por subrogacion</option>
                    <option value="14">14 Pago por consignacion</option>
                    <option value="15">15 Condonacion</option>
                    <option value="17">17 Compensacion</option>
                    <option value="23">23 Novacion</option>
                    <option value="24">24 Confusion</option>
                    <option value="25">25 Remision de deuda</option>
                    <option value="26">26 Prescripcion o caducidad</option>
                    <option value="27">27 A satisfaccion del acreedor</option>
                    <option value="28">28 Tarjeta de debito</option>
                    <option value="29">29 Tarjeta de servicios</option>
                    <option value="30">30 Aplicacion de anticipos</option>
                    <option value="31">31 Intermediario pagos</option>
                    <option value="99">99 Por definir</option>
                  </Input>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Cond. Pago</Label>
                  <Input
                    name="condicionesPagoSAT"
                    type="text"
                    value={d.condicionesPagoSAT || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Metodo Pago</Label>
                  <Input
                    name="metodoPagoSAT"
                    type="select"
                    value={d.metodoPagoSAT || "PPD"}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  >
                    <option value="PPD">PPD</option>
                    <option value="PUE">PUE</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Email</Label>
                  <Input
                    name="email"
                    type="text"
                    value={d.email || ""}
                    onChange={(e) => handleChangeDFExistente(d._id, e)}
                  />
                </Col>
              </Row>
            </div>
          ))}

          {inputFieldsDF.map((d) => (
            <div key={d.id} style={{ background: "#f7f7f7", borderRadius: 4, padding: 6, marginTop: 6 }}>
              <Row>
                <Col md={3}>
                  <Label>Alias</Label>
                  <Input
                    name="alias"
                    type="text"
                    value={d.alias}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Razon Social *</Label>
                  <Input
                    name="razon_social"
                    type="text"
                    value={d.razon_social}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
                <Col md={2}>
                  <Label>RFC *</Label>
                  <Input
                    name="RFC"
                    type="text"
                    value={d.RFC}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
                <Col md={2}>
                  <Label>CP *</Label>
                  <Input
                    name="cp"
                    type="text"
                    value={d.cp}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
                <Col md={1}>
                  <br />
                  <Button color="danger" size="sm" onClick={() => handleRemoveDF(d.id)}>
                    <i className="fas fa-times"></i>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Reg Fiscal *</Label>
                  <Input
                    name="regFiscal"
                    type="select"
                    value={d.regFiscal}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="601">601 General de Ley Personas Morales</option>
                    <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                    <option value="605">605 Sueldos y Salarios</option>
                    <option value="608">608 Demas Ingresos</option>
                    <option value="612">612 PF Actividades Empresariales</option>
                    <option value="616">616 Sin Obligacion Fiscal</option>
                    <option value="621">621 Incorporacion Fiscal</option>
                    <option value="626">626 RESICO</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Uso CFDI</Label>
                  <Input
                    name="usoCFDI"
                    type="select"
                    value={d.usoCFDI}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="G01">G01 Adquisicion de mercancias</option>
                    <option value="G02">G02 Devoluciones, descuentos o bonificaciones</option>
                    <option value="G03">G03 Gastos en general</option>
                    <option value="I01">I01 Construcciones</option>
                    <option value="I02">I02 Mobiliario y equipo de oficina por inversiones</option>
                    <option value="I03">I03 Equipo de transporte</option>
                    <option value="I04">I04 Equipo de computo y accesorios</option>
                    <option value="I05">I05 Dados, troqueles, moldes, matrices y herramental</option>
                    <option value="I06">I06 Comunicaciones telefonicas</option>
                    <option value="I07">I07 Comunicaciones satelitales</option>
                    <option value="I08">I08 Otra maquinaria y equipo</option>
                    <option value="D01">D01 Honorarios medicos, dentales y gastos hospitalarios</option>
                    <option value="D02">D02 Gastos medicos por incapacidad o discapacidad</option>
                    <option value="D03">D03 Gastos funerales</option>
                    <option value="D04">D04 Donativos</option>
                    <option value="D05">D05 Intereses reales efectivamente pagados por creditos hipotecarios</option>
                    <option value="D06">D06 Aportaciones voluntarias al SAR</option>
                    <option value="D07">D07 Primas por seguros de gastos medicos</option>
                    <option value="D08">D08 Gastos de transportacion escolar obligatoria</option>
                    <option value="D09">D09 Depositos en cuentas para el ahorro, primas que tengan como base planes de pensiones</option>
                    <option value="D10">D10 Pagos por servicios educativos (colegiaturas)</option>
                    <option value="S01">S01 Sin efectos fiscales</option>
                    <option value="CP01">CP01 Pagos</option>
                    <option value="CN01">CN01 Nomina</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Forma Pago SAT</Label>
                  <Input
                    name="formaPagoSAT"
                    type="select"
                    value={d.formaPagoSAT}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  >
                    <option value="">Selecciona</option>
                    <option value="01">01 Efectivo</option>
                    <option value="02">02 Cheque nominativo</option>
                    <option value="03">03 Transferencia electronica de fondos</option>
                    <option value="04">04 Tarjeta de credito</option>
                    <option value="05">05 Monedero electronico</option>
                    <option value="06">06 Dinero electronico</option>
                    <option value="08">08 Vales de despensa</option>
                    <option value="12">12 Dacion en pago</option>
                    <option value="13">13 Pago por subrogacion</option>
                    <option value="14">14 Pago por consignacion</option>
                    <option value="15">15 Condonacion</option>
                    <option value="17">17 Compensacion</option>
                    <option value="23">23 Novacion</option>
                    <option value="24">24 Confusion</option>
                    <option value="25">25 Remision de deuda</option>
                    <option value="26">26 Prescripcion o caducidad</option>
                    <option value="27">27 A satisfaccion del acreedor</option>
                    <option value="28">28 Tarjeta de debito</option>
                    <option value="29">29 Tarjeta de servicios</option>
                    <option value="30">30 Aplicacion de anticipos</option>
                    <option value="31">31 Intermediario pagos</option>
                    <option value="99">99 Por definir</option>
                  </Input>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Cond. Pago</Label>
                  <Input
                    name="condicionesPagoSAT"
                    type="text"
                    value={d.condicionesPagoSAT}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Metodo Pago</Label>
                  <Input
                    name="metodoPagoSAT"
                    type="select"
                    value={d.metodoPagoSAT}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  >
                    <option value="PPD">PPD</option>
                    <option value="PUE">PUE</option>
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Email</Label>
                  <Input
                    name="email"
                    type="text"
                    value={d.email}
                    onChange={(e) => handleChangeDFNuevo(d.id, e)}
                  />
                </Col>
              </Row>
            </div>
          ))}

          <br />
          <Button size="sm" color="info" onClick={handleAddDF}>
            <i className="fas fa-plus"></i> Agregar dato de facturacion
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveDatosFacturacion}>
            Guardar
          </Button>
          <Button color="secondary" onClick={() => setAbrirEditarDF(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Informacion del Cliente</h4>
        </ModalHeader>
        <ModalBody>
          <div className="card container">
            <Table size="sm" borderless>
              <tbody>
                <tr>
                  <td>Nombre Comercial</td>
                  <td>{nombre_comercial_info}</td>
                </tr>
                <tr>
                  <td>Telefono</td>
                  <td>{telefono_info}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{email_info}</td>
                </tr>
                <tr>
                  <td>Forma de Pago</td>
                  <td>{forma_pago_info}</td>
                </tr>
                <tr>
                  <td>Razon Social</td>
                  <td>{razon_social_info}</td>
                </tr>
                <tr>
                  <td>Grupo</td>
                  <td>{grupo_info}</td>
                </tr>
                <tr>
                  <td>Direccion</td>
                  <td>{direccion_info}</td>
                </tr>
                <tr>
                  <td>Cobrador</td>
                  <td>{colaborador_info} </td>
                </tr>
                <tr>
                  <td>Observaciones</td>
                  <td>{observaciones_info}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalPassword} toggle={togglePassword}>
        <ModalHeader toggle={togglePassword}>
          <h4>Cambio de contraseña</h4>
        </ModalHeader>
        <ModalBody>
          <PasswordCliente idCliente={idPassword} />
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar cliente {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                disabled
                // onChange={(e) => {
                //   setCodigo(e.target.value);
                // }}
              />
            </Col>
            <Col md={3}>
              <Label>Nombre Comercial</Label>
              <Input
                type="text"
                placeholder="Nombre Comercial"
                value={nombre_comercial}
                required
                onChange={(e) => {
                  setNombreComercial(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={3}>
              <Label>Razon Social</Label>
              <Input
                type="text"
                placeholder="Razon Social"
                value={razon_social}
                onChange={(e) => {
                  setRazonSocial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>RFC</Label>
              <Input
                type="text"
                placeholder="RFC"
                value={RFC}
                onChange={(e) => {
                  setRFC(e.target.value);
                }}
              />
            </Col> */}
          

          {/* <Row>
            <Col md={6}>
              <Label>Calle</Label>
              <Input
                type="text"
                placeholder="Calle"
                value={calle}
                onChange={(e) => {
                  setCalle(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Ext</Label>
              <Input
                type="text"
                placeholder="No. Ext"
                value={numero_ext}
                onChange={(e) => {
                  setNumeroExt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Int</Label>
              <Input
                type="text"
                placeholder="No. Int"
                value={numero_int}
                onChange={(e) => {
                  setNumeroInt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Pais</Label>
              <Input
                type="text"
                placeholder="Pais"
                value={pais}
                onChange={(e) => {
                  setPais(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Estado</Label>
              <Input
                type="select"
                value={estado}
                onChange={(e) => {
                  setEstado(e.target.value);
                }}
              >
                <option value="">Selecciona</option>

                <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                <option value="BAJA CALIFORNIA NORTE">
                  BAJA CALIFORNIA NORTE
                </option>
                <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                <option value="CAMPECHE">CAMPECHE</option>
                <option value="CHIAPAS">CHIAPAS</option>
                <option value="CHIHUAHUA">CHIHUAHUA</option>
                <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                <option value="COAHUILA">COAHUILA</option>
                <option value="COLIMA">COLIMA</option>
                <option value="DURANGO">DURANGO</option>
                <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                <option value="GUANAJUATO">GUANAJUATO</option>
                <option value="GUERRERO">GUERRERO</option>
                <option value="HIDALGO">HIDALGO</option>
                <option value="JALISCO">JALISCO</option>
                <option value="MICHOACAN">MICHOACAN</option>
                <option value="MORELOS">MORELOS</option>
                <option value="NAYARIT">NAYARIT</option>
                <option value="NUEVO LEON">NUEVO LEON</option>
                <option value="OAXACA">OAXACA</option>
                <option value="PUEBLA">PUEBLA</option>
                <option value="QUERETARO">QUERETARO</option>
                <option value="QUINTANA ROO">QUINTANA ROO</option>
                <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                <option value="SINALOA">SINALOA</option>
                <option value="SONORA">SONORA</option>
                <option value="TABASCO">TABASCO</option>
                <option value="TAMAULIPAS">TAMAULIPAS</option>
                <option value="TLAXCALA">TLAXCALA</option>
                <option value="VERACRUZ">VERACRUZ</option>
                <option value="YUCATAN">YUCATAN</option>
                <option value="ZACATECAS">ZACATECAS</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Ciudad</Label>
              <Input
                type="text"
                placeholder="Ciudad"
                value={ciudad}
                onChange={(e) => {
                  setCiudad(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Delegacion</Label>
              <Input
                type="text"
                placeholder="Delegacion o Municipio"
                value={delegacion}
                onChange={(e) => {
                  setDelegacion(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Colonia</Label>
              <Input
                type="text"
                placeholder="Colonia"
                value={colonia}
                onChange={(e) => {
                  setColonia(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>CP</Label>
              <Input
                type="number"
                placeholder="CP"
                value={cp}
                onChange={(e) => {
                  setCP(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Telefono</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono}
                onChange={(e) => {
                  setTelefono(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Email</Label>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Vendedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedVendedor}
                onChange={(e) => {
                  setSelectedVendedor(e.target.value);
                }}
              >
                <option value="0">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
          </Row> */}

            {/* Email y teléfono: se usan para mandarle la nota al cliente */}
            <Col md={3}>
              <Label className="mr-sm-2">
                Email{" "}
                <i
                  className="fas fa-info-circle"
                  title="Puedes capturar varios correos separados por coma. La nota se manda a todos."
                ></i>
              </Label>
              <Input
                type="text"
                placeholder="correo@cliente.com, otro@cliente.com"
                value={email === "NA" || email === "a@a.a" ? "" : email}
                onChange={(e) => setEmail(e.target.value || "NA")}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Telefono</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono === "NA" ? "" : telefono}
                onChange={(e) => setTelefono(e.target.value || "NA")}
              />
            </Col>

            <Col md={3}>
              <Label className="mr-sm-2">Vendedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedVendedor}
                onChange={(e) => setSelectedVendedor(e.target.value)}
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => (
                    <option key={a._id} value={a._id}>
                      {a.nombre} {a.apellido}
                    </option>
                  ))}
              </Input>
            </Col>
            </Row>
          <Row>
            <Col md={3}>
              <Label>Forma de Pago</Label>
              <Input
                type="select"
                placeholder="Forma de Pago"
                value={forma_pago}
                onChange={(e) => {
                  setFormaPago(e.target.value);
                }}
              >
                <option value="0">Forma de Pago</option>
                <option value="Contado">Contado</option>
                <option value="Credito">Credito</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Requiere Factura</Label>
              <Input
                type="select"
                value={requiereFactura}
                onChange={(e) => setRequiereFactura(e.target.value)}
              >
                <option value="No">No</option>
                <option value="Si">Sí</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Plazo 1 (dias)</Label>
              <Input
                type="select"
                value={plazo}
                onChange={(e) => setPlazo(e.target.value)}
              >
                <option value="">Plazo</option>
                <option value="0">0 (contra entrega)</option>
                  <option value="15">15</option>
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="90">90</option>
                <option value="120">120</option>
                <option value="150">150</option>
                <option value="180">180</option>
              </Input>
            </Col>
            <Col md={1}>
              <Label>% Plazo 1</Label>
              <Input
                type="number"
                min="0"
                max="100"
                step="any"
                value={porcentajePlazo1}
                onChange={(e) => setPorcentajePlazo1(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Plazo 2 (dias)</Label>
              <Input
                type="select"
                value={plazo2}
                onChange={(e) => setPlazo2(e.target.value)}
              >
                <option value="0">0</option>
                  <option value="15">15</option>
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="90">90</option>
                <option value="120">120</option>
                <option value="150">150</option>
                <option value="180">180</option>
              </Input>
            </Col>
            <Col md={1}>
              <Label>% Plazo 2</Label>
              <Input
                type="number"
                min="0"
                max="100"
                step="any"
                value={porcentajePlazo2}
                onChange={(e) => setPorcentajePlazo2(e.target.value)}
              />
            </Col>
            </Row>
            <Row>
            <Col md={3}>
              <Label>Empresa</Label>
              <Input
                type="select"
                value={selectedEmpresa}
                onChange={(e) => setSelectedEmpresa(e.target.value)}
              >
                <option value="">Selecciona una Empresa</option>
                {empresasList
                  .filter((e) => !e.is_active || e.is_active === "Si")
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((e) => (
                    <option key={e._id} value={e._id}>
                      {e.name}
                    </option>
                  ))}
              </Input>
            </Col>
           
                <Col md={3}>
              <Label className="mr-sm-2">Almacen</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedAreaEdit}
                onChange={(e) => {
                  setSelectedAreaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona un almacen</option>
                {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
              </Input>
            </Col>

            {/* <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col> */}
 <Col md={3}>
                <Label>Lista de Precios</Label>
                <Input
                  type="select"
                  value={listaPrecios}
                  onChange={(e) => {
                    setListaPrecios(e.target.value);
                  }}
                >
                  <option value={1}>Lista 1</option>
                  <option value={2}>Lista 2</option>
                  <option value={3}>Lista 3</option>
                  <option value={4}>Lista 4</option>
                  </Input>
              </Col>
               <Col md={3}>
              <Label>Calificadora</Label>
              <Input
                type="select"
                placeholder="Calificadora"
                value={calificadora}
                onChange={(e) => {
                  setCalificadora(e.target.value);
                }}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </Input>
            </Col>
          </Row>

                      {/* <Row>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="623">623 Opcional para Grupos de Sociedades</option>
                  <option value="624">624 Régimen de los Coordinados</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G03">G03 Gastos en general</option>
                  <option value="G23">G23 Opcional para grupos de sociedades</option>
                  <option value="S01">S01 Sin efectos fiscales</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>

              </Row>
               <Row>

              <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
         {/* <Row>
             <Col md={3}>
                <Label className="mr-sm-2">Alertas Ventas</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasVentas}
                  onChange={(e) => {
                    setAlertasVentas(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Estado Cuenta</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasEdoCta}
                  onChange={(e) => {
                    setAlertasEdoCta(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Marketing</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasMarketing}
                  onChange={(e) => {
                    setAlertasMarketing(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col> 
              

            </Row>*/}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Z2: modal fichas / archivos del cliente */}
      <Modal size="xl" isOpen={modalFichaCliente} toggle={toggleFichaCliente}>
        <ModalHeader toggle={toggleFichaCliente}>
          <h4>
            Fichas / Archivos del cliente
            {fichaResources.length > 0 && <span> · {fichaResources.length} archivos</span>}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Col md={9}>
              <Label>Subir archivos (imágenes o PDF)</Label>
              <Input
                type="file"
                multiple
                accept="image/*,application/pdf"
                onChange={(e) => setFichaArchivos(Array.from(e.target.files || []))}
              />
              {fichaArchivos.length > 0 && (
                <div className="mt-1"><small>{fichaArchivos.length} seleccionado(s)</small></div>
              )}
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button color="success" size="sm" onClick={subirFichasCliente} disabled={!fichaArchivos.length}>
                <i className="fas fa-upload"></i> Subir
              </Button>
            </Col>
          </Row>
          {fichaResources.length > 0 ? (
            fichaResources.map((r, i) => (
              <Row key={r.public_id || r.url} className="mb-4">
                <Col md={12}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <strong>Archivo {i + 1}</strong>
                    <div>
                      <a href={r.url} target="_blank" rel="noreferrer" className="mr-3">
                        Abrir en otra pestaña
                      </a>
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => eliminarFichaCliente(r.public_id)}
                        disabled={!r.public_id}
                      >
                        <i className="fas fa-trash"></i> Eliminar
                      </Button>
                    </div>
                  </div>
                  <iframe
                    title={`Ficha ${i + 1}`}
                    src={r.url}
                    style={{ width: "100%", height: "60vh", border: 0 }}
                  />
                </Col>
              </Row>
            ))
          ) : (
            <h5 className="text-muted">No hay archivos subidos.</h5>
          )}
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoClientes;
